const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/GoToAppointmentBookingButton.tsx';
import { Button } from '@mui/material';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { goToAppointmentBooking } from 'App/utils/history';
import textMapAppointment from 'App/pages/appointment/translations';
import { selectCanUserBookAppointment } from 'App/store/appointment';

type GoToAppointmentBookingButtonProps = {
    className?: string;
    text?: string;
};

export const GoToAppointmentBookingButton = (props: GoToAppointmentBookingButtonProps) => {
    const { formatMessage } = useIntl();
    const history = useHistory();

    const userCanBookAppointment = useSelector(selectCanUserBookAppointment);

    if (!userCanBookAppointment) return null;

    const handleButtonClick = () => {
        goToAppointmentBooking(history);
    };

    return (
        <Button className={cx(props.className)} variant={'contained'} color={'primary'} onClick={handleButtonClick}>
            {props.text ?? formatMessage(textMapAppointment.bookAppointment)}
        </Button>
    );
};
